import * as Yup from 'yup'
import {FieldProps} from './Form'

export const buildValidationSchema = (
  fields: FieldProps[] | ((options: {values: any}) => FieldProps[]),
  data?: Record<string, any>
) => {
  const isEditing = data && data.id
  let flds = typeof fields === 'function' ? fields({values: {}}) : structuredClone(fields)
  flds = flds?.filter((f: any) => isEditing ? f.edit !== false : f.create !== false)
  const fieldObj: any = {}
  const initialValues: any = data || {}
  flds?.forEach((field) => {
    field.type = field.type || 'text'
    const keyParts = field.name.split('.').filter(Boolean)
    let curr = initialValues
    let curr1 = fieldObj
    // let curData = data
    keyParts.forEach((part, idx) => {
      if (idx === keyParts.length - 1) {
        if (curr[part] === undefined || curr[part] === null) {
          curr[part] = field.initialValue
            ? field.initialValue
            : field.type === 'date'
            ? new Date().toISOString().split('T')[0]
            : field.type === 'switch'
            ? true
            : field.type === 'additional-fields'
            ? []
            : ''
        }
        curr1[part] = field
      } else {
        if (!curr[part]) curr[part] = {}
        if (!curr1[part]) curr1[part] = {}
        curr = curr[part]
        curr1 = curr1[part]
      }
    })
  })
  // console.log(initialValues)
  const buildYupSchema = (fieldObj: any) => {
    const schema: any = {}
    Object.entries(fieldObj).forEach(([key, value]: [string, any]) => {
      if (!value.name) {
        schema[key] = buildYupSchema(value)
        return
      }
      let validator
      switch (value.type) {
        case 'switch':
          validator = Yup.boolean()
          break
        case 'file':
          validator = Yup.string()
            .when(key + '_to_upload', {
              is: (val: File) => !(val instanceof File) && value.required,
              then: Yup.string().required(),
              otherwise: Yup.string(),
            })
            .label(value.label || key)
          break
        case 'additional-fields':
          validator = Yup.array()
          break
        default:
          validator = Yup.string()
          if (value.type === 'email') validator = validator.email()
      }
      if (value.required && value.type !== 'file') validator = validator.required()
      schema[key] = validator.label(value.label || key)
    })
    return Yup.object().shape(schema)
  }

  return {schema: buildYupSchema(fieldObj), initialValues}
}
